const currentJourney = (state = [], action) => {

	switch (action.type) {

		case 'SET_CURRENT_JOURNEY':

			const currentJourney = action.current;

			return {
				...state,
				currentJourney
			};

		default:
			return state;
	}
}

export default currentJourney;



// WEBPACK FOOTER //
// ./src/reducers/currentJourney.js